import { useLazyQuery } from '@apollo/client';

import GetHistoryAuditQuery from '@/graphql/contracts/getHistoryAudit.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetHistoryAudit, GetHistoryAuditVariables } 
  from '@/graphql/contracts/_generated_/getHistoryAudit.query';
import { EntityTypeEnum } from '@/graphql/contracts/_generated_/contracts';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

export function useGetPurchaseOrdersHistory() {
  const [_getPurchaseOrdersHistory, { data, loading }] = useLazyQuery<
  GetHistoryAudit,
  GetHistoryAuditVariables
  >(GetHistoryAuditQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) => {
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      });
    },
  });

  const getPurchaseOrdersHistory = (purchaseOrderId: string) => {
    _getPurchaseOrdersHistory({
      variables: {
        entityId: purchaseOrderId,
        entityType: EntityTypeEnum.PURCHASE_ORDER,
      },
    });
  };

  return {
    getPurchaseOrdersHistory,
    purchaseOrdersHistory: data?.history,
    isLoading: loading,
  };
}
